import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {
    Box,
    Button,
    Link,
    MenuItem,
    Select,
    Skeleton,
    Stack,
    Typography,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SimCardDownloadOutlinedIcon from '@mui/icons-material/SimCardDownloadOutlined';
import { BackArrowIcon, EyeIcon, } from '../icons';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import { GlobalStyles } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import '../../src/assets/css/admission.css'
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useNotification } from '../hooks/useNotification';
import { downloadPaymentRequestList, fetchAllPaymentRequestList, paymentRequestMarkAsPaid } from '../api/paymentRequestApi';
import { setPaginationFiled } from '../containers/pagination-container/reducer/paginationSlice';
import CommonFilterTab from '../components/common/CommonFilterTab';
import CommonTableFormat from '../components/common/CommonTableFormat';
import RejectPaymentModal from '../components/PaymentRequestData/RejectPaymentModal';
import { creditTypeList, defaultPaginationValues, filterTypeOptions, paymentRequestStatusList } from '../utils/constant';
import { formatMultiQueryParams, jsonParserFormatter } from '../utils/helperFunction';
import CommonDataTable from '../components/common/CommonDataTable';
import { setFilterField } from '../containers/filter-container/reducer/filterSlice';


const PaymentRequest = ({ isHandlBtn = false }) => {
    const dispatch = useDispatch()
    const filterSlice = useSelector(state => state.filter?.filters)
    const navigate = useNavigate()
    const LOCATION_FILTER = `filters:${window.location.pathname}`
    const [rows, setRows] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [rowCount, setRowCount] = React.useState(0);
    const { showErrorNotification, showSuccessNotification } = useNotification()
    const [isRejectModalOpen, setIsRejectModalOpen] = React.useState(false);
    const [selectedRequest, setSelectedRequest] = React.useState(null);
    const [saving, setSaving] = React.useState(false);
    const [downloading, setDownloading] = React.useState(false)
    const [searchFilter, setSearchFilter] = React.useState({})
    const [pageFilters, setPageFilters] = React.useState(defaultPaginationValues);
    const [isRender, setIsRender] = React.useState(false)


    const handleFliterSliceChange = (values = {}, isReset = false) => {
        let isQuery = typeof values === "object" && Object.keys(values)?.length
        isQuery && dispatch(setFilterField({ pathname: LOCATION_FILTER, filters: JSON.stringify({ ...(isReset ? {} : pageFilters), ...defaultPaginationValues, ...values }) }))
    }

    const fetchDetails = () => {
        const multiFilter = formatMultiQueryParams(filterSlice[LOCATION_FILTER])
        fetchAllPaymentRequestList({ setRows, filterData: { ...searchFilter, ...multiFilter, isMultiFilter: true }, setRowCount, setLoading })
            .catch(error => {
                showErrorNotification(error?.message)
            })
    }

    const downloadDetails = () => {
        if (downloading) return
        downloadPaymentRequestList({ setDownloading, filterData: { isDownload: true } })
            .then(res => {
                showSuccessNotification("Successfully downloaded")
            }).catch(error => {
                showErrorNotification(error?.message)
            })
    }


    const handleMarkAsPaid = (id) => {
        if (id) {
            paymentRequestMarkAsPaid({ transactionId: id, setSaving })
                .then(result => {
                    showSuccessNotification(result?.message || "Marked as paid")
                    fetchDetails()
                })
                .catch(error => {
                    showErrorNotification(error?.message)
                })
        }
    }

    const filteredRows = rows

    const btnStatuscode = (btnStatus) => {
        // eslint-disable-next-line default-case
        switch (btnStatus) {
            case 'Succeeded':
                return { backgroundColor: '#c8e6c9', textColor: '#1b5e20' };
            case 'Pending':
                return { backgroundColor: '#fff3e0', textColor: '#ff9800' };
            case 'Failed':
                return { backgroundColor: '#ffcdd2', textColor: '#b71c1c' };
            default:
                return { backgroundColor: '#ffcdd2', textColor: '#6dc1c4ff' };
        }
    };

    const columns = [
        {
            field: 'sNo',
            headerName: 'S. No.',
            width: 60, // fixed small width for serial number
            sortable: false,
            filterable: false,
            cellClassName: 'text-center',
            headerClassName: 'text-center textcenterclass',
            disableColumnMenu: true,
            // renderCell: (params) => filteredRows.findIndex((r) => r.id === params.row.id) + 1,
        },
        {
            field: 'studentId',
            headerName: 'Student Id',
            flex: 1,
            minWidth: 130,
            cellClassName: ' text-center',
            headerClassName: 'text-center textcenterclass',
            filterColumnName: "studentId",
            filterType: filterTypeOptions.string,
            renderCell: (params) => {
                return loading ? (
                    <Skeleton width={70} />
                ) : (
                    <Box>
                        {params.value}
                    </Box>
                );
            },
        }
        ,
        {
            field: 'StudentName',
            headerName: 'Student Name',
            flex: 2,
            minWidth: 240,
            filterColumnName: "user.fullName",
            filterType: filterTypeOptions.string,
            renderCell: (params) => {
                const { logo, StudentName } = params.row;

                const getInitials = (fullName) => {
                    if (!fullName) return '';
                    const words = fullName.trim().split(' ').filter(Boolean);
                    if (words.length === 1) return words[0][0]?.toUpperCase() || '';
                    if (words.length === 2) return (words[0][0] + words[1][0]).toUpperCase();
                    return (words[0][0] + words[1][0] + words[2][0]).toUpperCase();
                };

                const stringToColor = (str) => {
                    let hash = 0;
                    for (let i = 0; i < str.length; i++) {
                        hash = str.charCodeAt(i) + ((hash << 5) - hash);
                    }
                    const c = (hash & 0x00ffffff).toString(16).toUpperCase();
                    return '#' + '00000'.substring(0, 6 - c.length) + c;
                };


                return loading ? (
                    <Skeleton width={150} />
                ) : (
                    <Box
                        display="flex"
                        alignItems="center"
                        gap={1}
                        sx={{ cursor: 'pointer', marginTop: '10px' }}

                    >
                        {logo ? (
                            <Box
                                sx={{
                                    minWidth: 35,
                                    minHeight: 35,
                                    maxWidth: 35,
                                    maxHeight: 35,
                                    borderRadius: '50%',
                                    backgroundColor: '#1075FF26',
                                    color: '#1C74ED',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontWeight: 500,
                                    fontSize: '14px',
                                    textTransform: 'uppercase',
                                    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.15)',
                                }}
                            >
                                {getInitials(StudentName)}
                            </Box>
                        ) : (
                            <Box
                                sx={{
                                    minWidth: 35,
                                    minHeight: 35,
                                    maxWidth: 35,
                                    maxHeight: 35,
                                    borderRadius: '50%',
                                    backgroundColor: '#1075FF26',
                                    color: '#1C74ED',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontWeight: 500,
                                    fontSize: '14px',
                                    textTransform: 'uppercase',
                                    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.15)',
                                }}
                            >
                                {getInitials(StudentName)}
                            </Box>
                        )}
                        <Box>
                            <Typography sx={{ fontWeight: 500, fontSize: '13px', color: '#000' }}>
                                {params.value}
                            </Typography>

                        </Box>
                    </Box>
                );
            },
        },
        {
            field: 'phone',
            headerName: 'Mobile No.',
            flex: 2,
            minWidth: 190,
            filterColumnName: "user.phone",
            filterType: filterTypeOptions.string,
            renderCell: (params) => {
                const { phone } = params.row;
                return loading ? (
                    <Skeleton width={150} />
                ) : (
                    <Box sx={{ marginTop: '18px' }}>

                        {phone && (
                            <Typography sx={{ fontWeight: 500, fontSize: '13px', color: '#363853' }}>
                                <LocalPhoneOutlinedIcon sx={{ color: '#363853', fontSize: '18px', marginRight: '4px' }} />  {phone}
                            </Typography>
                        )}
                    </Box>
                );
            },
        },
        {
            field: 'WithdrawalAmount',
            headerName: 'Withdrawal Amount',
            flex: 2,
            cellClassName: 'text-center',
            headerClassName: 'text-center textcenterclass',
            minWidth: 150,
            filterColumnName: "amount",
            filterType: filterTypeOptions.numberRange,
            renderCell: (params) => {
                const { WithdrawalAmount } = params.row;
                return loading ? (
                    <Skeleton width={150} />
                ) : (
                    <Box sx={{ marginTop: '18px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>


                        {WithdrawalAmount && (
                            <Typography sx={{ fontWeight: 500, fontSize: '13px', color: '#000' }}>
                                {WithdrawalAmount}
                            </Typography>
                        )}
                    </Box>
                );
            },
        },
        {
            field: 'bankUpiDetails',
            headerName: 'Bank /UPI Details',
            flex: 1,
            minWidth: 170,
            filterColumnName: "bankDetail.bankName",
            filterType: filterTypeOptions.string,
            renderCell: (params) =>
                loading ? (
                    <Skeleton variant="circular" width={24} height={24} />
                ) : (
                    <Box sx={{ display: 'flex', marginTop: '18px' }}>
                        <Box  >
                            <Typography sx={{ fontSize: '14px', color: '#363853', fontWeight: '400' }}>
                                {
                                    params.value
                                }
                            </Typography>
                        </Box>
                    </Box>

                ),
        },
        {
            field: 'withdrawalMode',
            headerName: 'Withdrawal Mode',
            flex: 2,
            minWidth: 130,
            cellClassName: 'text-center ',
            headerClassName: 'text-center leadcourcecenter',
            filterColumnName: "creditType",
            filterType: filterTypeOptions.selection,
            selection:creditTypeList,
            renderCell: (params) => {
                const { withdrawalMode, transType } = params.row;
                return loading ? (
                    <Skeleton width={150} />
                ) : (
                    <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '-22px' }}>
                        <Box >
                            <img src={withdrawalMode} style={{ marginBottom: '3px' }}></img>
                            <Typography sx={{ fontSize: '14px', color: '#363853', fontWeight: '400' }}>
                                {transType}
                            </Typography>
                        </Box>
                    </Box>
                );
            },
        },
        {
            field: 'requestDate',
            headerName: 'Request Date',
            flex: 2,
            cellClassName: 'text-center ',
            headerClassName: 'text-center leadcourcecenter',
            minWidth: 130,
            filterColumnName: "createdAt",
            filterType: filterTypeOptions.dateRange,
            renderCell: (params) => {
                const { requestDate } = params.row;
                return loading ? (
                    <Skeleton width={150} />
                ) : (
                    <Box sx={{ color: '#000' }}>
                        {requestDate}
                    </Box>

                );
            },
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 2,
            cellClassName: 'text-center ',
            headerClassName: 'text-center leadcourcecenter',
            minWidth: 100,
            filterColumnName: "status",
            filterType: filterTypeOptions.selection,
            selection: paymentRequestStatusList,
            renderCell: (params) => {
                const { status } = params.row;
                const { backgroundColor, textColor } = btnStatuscode(status)
                return loading ? (
                    <Skeleton width={150} />
                ) : (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', }}>
                        <Typography
                            size="small"
                            sx={{
                                display: 'inline-block',
                                textAlign: 'center',
                                borderRadius: '14px',
                                background: backgroundColor,
                                padding: '2px 12px',
                                color: textColor,
                                fontWeight: 500,
                                fontSize: '12px',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            {status}
                        </Typography>
                    </Box>

                );
            },
        },
        {
            field: 'referralBonus',
            headerName: 'Referral Bonus',
            flex: 2,
            cellClassName: ' textrightclass cellclastextright',
            headerClassName: ' cashvackamntclass textrightclass',
            minWidth: 130,
            filterColumnName: "amount",
            filterType: filterTypeOptions.numberRange,
            renderCell: (params) => {
                const { referralBonus } = params.row;
                return loading ? (
                    <Skeleton width={150} />
                ) : (
                    <Box sx={{ color: '#000' }}>
                        {referralBonus}
                    </Box>

                );
            },
        },
        {
            field: 'email',
            headerName: 'Email ID',
            flex: 1,
            minWidth: 220,
            filterColumnName: "user.email",
            filterType: filterTypeOptions.string,
        },
        {
            field: 'action',
            headerName: 'Action',
            width: 200,
            filterable: false,
            headerClassName: 'justify-content-center',
            renderCell: (params) =>
                loading ? <Skeleton width={80} /> : <Stack direction="row" spacing={1} sx={{ justifyContent: 'start', alignItems: 'center', height: '100%' }}>
                    <Button onClick={() => params?.row?.transactionId && navigate(`/payment-requests/details/${params?.row?.transactionId}`)}
                        size="small"
                        variant="outlined" sx={{ border: 'none', textAlign: 'center', minWidth: 'auto', width: 40, height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center' }}

                    >
                        <EyeIcon />
                    </Button>
                    {
                        params?.row?.status === "Pending" ? <>
                            <Button
                                disabled={saving}
                                loading={saving}
                                onClick={() => { setSelectedRequest(params?.row); handleMarkAsPaid(params?.row?.id) }}
                                size="small"
                                variant="outlined" sx={{ border: 'none', textAlign: 'center', minWidth: 'auto', color: '#098B34', width: 40, height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center' }}

                            >
                                <CheckCircleIcon />
                            </Button>
                            <Button
                                disabled={saving}
                                onClick={() => { setSelectedRequest(params?.row); setIsRejectModalOpen(true) }}
                                size="small"
                                variant="outlined" sx={{ border: 'none', textAlign: 'center', minWidth: 'auto', color: '#E45538', width: 40, height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center' }}

                            >
                                <CloseIcon />
                            </Button>
                        </> : <></>
                    }
                    {/* <Button
                        size="small"
                        variant="outlined" sx={{ border: 'none', textAlign: 'center', minWidth: 'auto', color: '#353535', width: 40, height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center' }}

                    >
                        <SimCardDownloadOutlinedIcon />
                    </Button> */}
                </Stack>,
        },

    ];

    React.useEffect(() => {
        fetchDetails()
    }, [filterSlice[LOCATION_FILTER], isRender])

    // handle extra filter tabs changes
    React.useEffect(() => {
        if (pageFilters?.page) {
            handleFliterSliceChange({ page: 0 })
        } else {
            setIsRender(!isRender)
        }
    }, [searchFilter])

    // parse page filters
    React.useEffect(() => {
        const values = jsonParserFormatter(filterSlice[LOCATION_FILTER])
        setPageFilters(values)
    }, [filterSlice[LOCATION_FILTER]])

    return (
        <>
            {/* Apply global styles to DataGrid dropdown menus */}
            {/* <GlobalStyles
                styles={{
                    '.MuiDataGrid-menuList': {
                        fontSize: '13px',
                        padding: '4px 0',
                    },
                    '.MuiDataGrid-panelContent': {
                        fontSize: '13px',
                        padding: '4px 0',
                    },
                    '.MuiSelect-select': {
                        fontSize: '13px',
                        padding: '4px 0',
                    },
                    '.MuiList-root .MuiButtonBase-root': {
                        fontSize: '13px',
                    },
                    '.MuiDataGrid-panelContent .MuiOutlinedInput-input': {
                        fontSize: '13px',
                    },
                    '.MuiDataGrid-columnsManagement .MuiFormControlLabel-root .MuiFormControlLabel-label': {
                        fontSize: '13px',
                    },
                    '.MuiDataGrid-menuList .MuiTypography-root': {
                        fontSize: '13px',
                    },
                    '.MuiDataGrid-menuList .MuiMenuItem-root': {
                        fontSize: '13px',
                        padding: '6px 12px',
                    },
                    '.MuiDataGrid-menuList .MuiMenuItem-root:hover': {
                        backgroundColor: '#f5f5f5',
                    },
                    '& .MuiDataGrid-columnHeaders': {
                        position: 'sticky',
                        top: 0,
                        zIndex: 2,
                        backgroundColor: '#fff',
                    },
                    '& .MuiDataGrid-cell.sticky-col-1': {
                        position: 'sticky',
                        left: 0,
                        background: '#fff',
                        zIndex: 2,
                    },
                    '& .MuiDataGrid-columnHeader.sticky-col-1': {
                        position: 'sticky',
                        left: 0,
                        background: '#fff',
                        zIndex: 3, // slightly higher than cell
                    },
                }}
            /> */}

            <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
                <div className="page-header" style={{ position: 'sticky', top: '4.5rem', zIndex: '9', padding: '10px 15px', borderBottom: '1px solid #E6E7E8', background: '#fff', marginBottom: '12px' }}>
                    <div className="row align-items-center">
                        <div className="col">
                            <Typography sx={{ fontSize: '18px', fontWeight: '600', color: '#15243E', display: 'flex', alignItems: 'center', gap: 1, }}>
                                {/* <Link href="/" className='d-flex'><BackArrowIcon /></Link> */}
                                Payment Requests </Typography>
                        </div>

                    </div>
                    {/* End Col */}
                </div>
                {/* Filter Toolbar */}



                <CommonFilterTab type='payment-request' module='payment' searchPlaceholder='Search Name/Mobile...' detailType='All Payment Requests' fetchList={setSearchFilter} showCount={rows?.length} rowCount={rowCount} isExportBtn={true} handleExport={downloadDetails} isExporting={downloading} />

                {/* Data Table */}
                <CommonDataTable columns={columns} rows={rows} idKey="field" loading={loading} filterEnabled={true} rowCount={rowCount}
                    pageFilters={pageFilters}
                    handleFliterSliceChange={handleFliterSliceChange}
                />
            </Box>


            {/* payment request detail modal */}
            <RejectPaymentModal
                id={selectedRequest?.id}
                open={isRejectModalOpen}
                onClose={() => { setIsRejectModalOpen(false); setSelectedRequest(null) }}
                refetch={fetchDetails}
            />



        </>
    )
}

export default PaymentRequest

